import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';

import * as ApiConfig from '../core/apiconfig';
import * as ReportModel from './index.model';
import { CodedLookup } from '../core/index.model';
import { HttpHeader } from '../core/httpheader';
import { Guid } from '../core/guid';
import { MobileAttach } from './mobile-attach.model';

@Injectable()
export class MobileattachService {

    private requestHeader: HttpHeader = new HttpHeader();
    private Http_Header_Request_Options: RequestOptions;

    
    private signapiUrl: string;

    constructor(private _http: Http) {
        
        this.signapiUrl = ApiConfig.SIGNAPI_URL;

    }

    RequestAttachment(model: MobileAttach) {
       let body = model;
        let url = this.signapiUrl + "Attachment/RequestAttachment/";
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();        
        return this._http.post(url, body, this.Http_Header_Request_Options)
            .map((res: Response) => res);
    }
    retriveAttachment(imgId: string, jurisId: number) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        let url = this.signapiUrl + "Attachment/GetAttachment/" + imgId + "/" + jurisId;
        return this._http
            .get(url, this.Http_Header_Request_Options)
            .toPromise()
            .then(response => {
                return response.json()
            })
            .catch(this.handleError);
    }
    RequestPicture(model: MobileAttach) {     
        let body = model;
        let url = this.signapiUrl + "Picture/RequestPicture/";
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();        
        return this._http.post(url, body, this.Http_Header_Request_Options)
            .map((res: Response) => res);
    }
    retrivePicture(imgId: string, jurisId: number) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        let url = this.signapiUrl + "Picture/GetPicture/" + imgId + "/" + jurisId;
        return this._http
            .get(url, this.Http_Header_Request_Options)
            .toPromise()
            .then(response => {
                return response.json()
            })
            .catch(this.handleError);
    }
    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/mobileattach.service.ts